export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";